import Header from "./Header/Header";
import PreviewingVideo from "./PreviewingVideo/PreviewingVideo";
import VideoConfig from "./VideoConfig/VideoConfig";
import VideoGroup from "./VideoGroup/VideoGroup";
import useCoverAndBg from "@/useStore/mixCutDetail/useCoverAndBg";
import React, {
  Profiler,
  createContext,
  useEffect,
  useState,
} from "react";
import { observer } from "mobx-react";
import { useNavigate, useParams } from "react-router-dom";
import useVideoGroup from "@/useStore/quickCut/useVideoGroup";
import useMixCutDetail from "@/useStore/quickCut/useMixCutDetail";
import {
  toIdGetEngineer,
  toIdGetEngineerContent,
} from "@/services/createSpace/engineering";
import useMixCutDetailInit from "@/useStore/mixCutDetail/useMixCutDetailInit";
import moment from "moment";
import { toIdGetCustomScript } from "@/services/createSpace/script";
import useParseScript from "@/useStore/quickCut/useQuickParseScript";
import usePreviewConfig from "@/useStore/preview/usePreview";
import useJsonToRenderObj from "@/useStore/mixCutDetail/useJsonToRenderObj";
import usePreviewInfo from "@/useStore/mixCutDetail/usePreviewInfo";
import { Button, Message, Modal } from "@arco-design/web-react";
import useMixCutDetailSave from "@/useStore/quickCut/useMixCutDetailSave";
import { useSearchParams } from 'react-router-dom';
import { v4 as uuid } from "uuid";
import "./quick.less";
import {
  bindingVideo,
  getBindVideoMaterial,
  getBindVideoMaterialStatus,
} from "@/services/mixCutDetail/mixCutDetail";
import mixCutDetailStore from "@/stores/mixCutDetailStore";
import VoLongButton from "@/components/VLButton/VLButton";
import { debounce } from "lodash";
import useNavigateTo from "@/utils/useNavigateTo";
import ChooseTransModal from "./Components/ChooseTransModal";
import QuickCutStore from "@/stores/quickCutStore";
import {batch_download} from "@/services/createSpace/material";
import QuickStore from "@/stores/quickCutStore";
import useMaterialPlayInfo from "@/useStore/quickCut/useMaterialPlayInfo";
import ComponseModal from "../QuickCutResult/ComponseModal/ComponseModal";
import useEditingResults from "@/requestHooks/mixCutDetail/useQuickEditingResults";
import {xun_clip, xun_clipPreview} from "@/services/quickcut";
export interface IMixCutDetailContext {
  videoGroupActive: number;
  videoGroupTransitionId: string;
  setVideoGroupActive: React.Dispatch<React.SetStateAction<number>>;
}

export const mixCutDetailContext = createContext<IMixCutDetailContext>(null);

const QuickCut = observer(() => {
  const [search] = useSearchParams();
  const { navigateTo } = useNavigateTo();
  const { id, script_id, keywords } = useParams();
  const { parseCutsomScript } = useParseScript();
  const { handleDecorationChange } = useCoverAndBg();
  const {
    projectCaption,
    projectSences,
    setProjectSences,
    handleProjectName,
    handleProjectSencesAdd,
    handleProjectSencesDelete,
    handleProjectVideoChange,
    handleChangeVideoItemStartAndDuration,
  } = useVideoGroup();
  const {
    data: tableList,
    msg,
    setData,
    loading,
    error,
    count,
  } = useEditingResults(id, Number(mixCutDetailStore.outputCount));
  const { quickSaveMixCutDetail } = useMixCutDetailSave();
  const { handleToChangeVideoIndexSetTitleAndCaption } = usePreviewConfig();
  const { projectMsg, handleProjectMsgSet } =
    useMixCutDetail();
  const { handletoOriginJsonRender } = useJsonToRenderObj();
  const { initAllMixCutDetal } = useMixCutDetailInit();
  const [videoConfigActiveIndex, setVideoConfigActiveIndex] = useState(1);
  const [videoGroupActive, setVideoGroupActive] = useState(0);
  const [videoGroupTransitionId, setVideoGroupTransitionId] =
    useState<string>("0");
  const [transVisible, setTransVisible] = useState(false);
  const [transIndex, setTansIndex] = useState(0)
  const [videoStatusList, setVideoStatusList] = useState([]);
  const { handleSaveMixCutDetailSave } = useMixCutDetailSave();
  const { handleMaterialItemAdd } = useMaterialPlayInfo();
  const { bgAudio, handleBgAudiosChange } = useCoverAndBg();
  const [componseVisible, setComponseVisible] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [timelineData, setTimelineData] = useState<any>(null);
  const [activeType, setActiveType] = useState(2);
  interface TemplateItem {
    cover: string;
    [key: string]: any;
  }

  interface BatchDownloadResponse {
    data?: {
      items: Array<{
        media_id: string;
        cover: string;
      }>;
    };
  }

  const changeTemplate = async (arr: TemplateItem[] = []): Promise<Array<TemplateItem & { cover_url?: string }>> => {
    if (!Array.isArray(arr) || arr.length === 0) return [];

    try {
      // 筛选出需要下载的media_id（非https链接）
      const itemsToDownload = arr.filter(item => item.cover && !item.cover.startsWith('https'));
      const media_ids = itemsToDownload.map(item => item.cover);
      // 如果有需要下载的封面
      if (media_ids.length > 0) {
        const res = await batch_download({ media_id: media_ids }) as BatchDownloadResponse;
        const items = res?.data?.items || [];
        const idToCover = new Map(items.map(item => [item.media_id, item.cover]));
        // 更新需要下载的项
        return arr.map(item => ({
          ...item,
          cover_url: item.cover.startsWith('https') ? item.cover : (idToCover.get(item.cover) || '')
        }));
      }
      // 如果都是https链接，直接返回
      return arr.map(item => ({
        ...item,
        cover_url: item.cover || ''
      }));
    } catch (error) {
      console.error('Failed to process template data:', error);
      return [];
    }
  }

  const changeScenes = async(arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return;
    const scenes = await Promise.all(arr.map(async (item) => {
      const materials = item.materials || [];
      if (materials.length > 0) {
        const media_ids = materials.map(m => m.media_id);
        try {
          const res = await batch_download({ media_id: media_ids });
          const items = res?.data?.items || [];
          const idToCover = Object.fromEntries(items.map(i => [i.media_id, i.cover]));
          const idToUrl = Object.fromEntries(items.map(i => [i.media_id, i.url]));
          materials.forEach((mat) => {
            handleMaterialItemAdd(mat.id, {
              url: idToUrl[mat.media_id],
              cover: idToCover[mat.media_id],
            });
          });
        } catch (err) {
          // 可选：错误处理
          console.error('batch_download error:', err);
        }
      }
      return {
        id: item.id,
        name: item?.name,
        materials: materials.map((li) => ({
          id: li.id,
          clip_id: Math.floor(Date.now() + Math.random() * 10000),
          media_id: li.media_id,
          type: li.type,
          width: li.width,
          height: li.height,
          start: item.start,
          duration: li.duration,
          is_cropped: item.is_cropped,
          speed: item.speed,
        })),
        material_mute: item.material_mute,
        type: item.type,
        duration: item.duration,
        settings: {
          copy: {
            copy_id: item.settings?.copy?.copy_id || null,
            copy_name: item.settings?.copy?.copy_name || null,
            copy_type: item.settings?.copy?.copy_type || null,
            variable_key: item.settings?.copy?.variable_key || null,
            variable_name: item.settings?.copy?.variable_name || null,
          },
          general: {
            mode: item.settings?.general?.mode || "follow_audio"
          },
        }
      };
    }));
    return scenes;
  };


  const convertDurationsToMilliseconds = (jsonData) => {
    const result = JSON.parse(JSON.stringify(jsonData)); // 创建深拷贝
    Object.keys(result).forEach(key => {
      if (result[key].duration !== undefined && result[key].duration > 1) {
        result[key].duration = result[key].duration / 1000
      }
    });
    return result;
  }

  const init = async (id: number, script?: number) => {
    try {
      console.log(id, 'ids')
      const result = await toIdGetEngineer(id);
      console.log(JSON.stringify(result), 'result')
      handleProjectMsgSet({
        ...result,
        updated_at: moment
          .unix(result.updated_at)
          .format("YYYY-MM-DD HH:mm") as any,
      });
      if (script) {
        const data = await toIdGetCustomScript(script);
        parseCutsomScript(data);
      } else {
        const contentResult = await toIdGetEngineerContent(id);
        const content = JSON.parse(contentResult);
        if (Object.keys(content || {}).length === 0) {
          QuickCutStore.initData();
        } else {
          console.log(content, 'content')
          if (!content.obfuscate) {
            content.obfuscate = {
              enabled: false
            }
          }
          QuickCutStore.quickcutData = content;
          // handletoOriginJsonRender(content);
          try {
            const arr = content.scenes;
            const scenes = await changeScenes(arr)
            if (QuickStore.quickcutData.transitions) {
              const transitions = convertDurationsToMilliseconds(content.transitions)
              QuickStore.quickcutData.transitions = transitions;
            }
            if (content.settings.video_template?.length > 0) {
              const video_template = await changeTemplate(content.settings.video_template);
              QuickStore.quickcutData.settings.video_template = video_template;
            }
            if (QuickStore.quickcutData.transitions) {
              const transitions = convertDurationsToMilliseconds(content.transitions)
              console.log(transitions, 'transitions')
              QuickStore.quickcutData.transitions = transitions;
            }
            if (content.settings.background) {
              QuickStore.quickcutData.settings.background = {
                ...content.settings.background,
                custom_file: content.settings.background.custom_file || [],
              }
            }
            if (content.settings.cover_template?.length > 0) {
              const cover_template = await changeTemplate(content.settings.cover_template);
              QuickStore.quickcutData.settings.cover_template = cover_template;
            }
            QuickStore.quickcutData.scenes = scenes;
            try {
              const ids = scenes.map((item) => item.materials.map((li) => li.id)).flat();
              await bindingVideo(id, ids);
            } catch (e) {
              console.log(e);
            }
          } catch (err) {
            console.error('parseCutsomScript error:', err);
          }
        }
      }
    } catch (e) {
      if (e === "资源不存在") {
        Message.error("工程已被删除！");
        setTimeout(() => {
          window.close();
        }, 3000);
        return;
      }
      // Message.error(e);
      // console.log(e);
    }
  };

  useEffect(() => {
    getStatusList();
  }, []);

  const getStatusList = () => {
    getBindVideoMaterialStatus(id).then((res) => {
      setVideoStatusList(res.items || []);
    });
  };

  const onRenderCallback = () => {
    // todo
  }

  useEffect(() => {
    if (id) {
      init(Number(id), Number(script_id));
    }
  }, [id]);

  // 选择转场
  const chooseTrans = (val) => {
    console.log(val);
  };
  const getPreviewInfo = async () => {
    setTimelineData(null)
    setIsLoading(true);
    try {
      const data = QuickStore.quickcutData
      const scenesWithUpdatedDuration = data.scenes.map(item => ({
        ...item,
        duration: item.duration * 1000
      }));
      const asyncGenerator = xun_clipPreview({
        session_id: Number(id),
        data: JSON.stringify({
          ...data,
          scenes: scenesWithUpdatedDuration,
          transitions: processTransitions(data.transitions),
          settings: {
            ...data.settings,
            video_template: data.settings?.video_template?.length > 0 ? data.settings?.video_template : makerVideo(),
          }
        }),
      });

      for await (const data of asyncGenerator) {
        console.log('收到预览数据:', data);

        if (data.event === 'progress') {
          // 更新进度提示
          // Message.info(data.message);
        } else if (data.event === 'result') {
          // 处理最终结果
          if (data.timeline) {
            setTimelineData({
              timeline: {
                ...JSON.parse(data.timeline)
              },
            });
            setIsLoading(false);
            setComponseVisible(true);
          } else {
            console.log('时间线数据为空');
          }
        } else if (data.event === 'error') {
          Message.warning(data.error);
          return
        }
      }
    } catch (error) {
      console.error('获取预览信息失败:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const processTransitions = (transitions) => {
    // 如果 transitions 为空或没有值，直接返回 null 或原对象
    if (!transitions || Object.keys(transitions).length === 0) {
      return null;
    }
    // 创建深拷贝以避免修改原对象
    const result = JSON.parse(JSON.stringify(transitions));
    // 遍历 transitions 对象的每个键
    for (const key in result) {
      if (Object.prototype.hasOwnProperty.call(result, key)) {
        const transition = result[key];
        // 如果存在 duration 属性且为数字，则乘以 1000
        if (transition.duration !== undefined && typeof transition.duration === 'number') {
          transition.duration = transition.duration * 1000;
        }
        // 如果有 effects 数组，也处理其中可能的 duration（如果需要的话）
        if (transition.effects && Array.isArray(transition.effects)) {
          transition.effects.forEach(effect => {
            if (effect.duration !== undefined && typeof effect.duration === 'number') {
              effect.duration = effect.duration * 1000;
            }
          });
        }
      }
    }
    return result;
  }
  useEffect(() => {
    handleSaveMixCutDetailSave();
  }, [JSON.stringify(QuickCutStore.quickcutData)]);

  const makerVideo = () => {
    const Id = Date.now() + parseInt(String(Math.random() * 10000));
    const Id1 = Date.now() + parseInt(String(Math.random() * 10000));
    return [{
      content: JSON.stringify({
        timeline: {
          VideoTracks: [
            {
              Id: Date.now() + parseInt(String(Math.random() * 10000)),
              Type: "Video",
              VideoTrackClips: [
                {
                  Id: Id,
                  Type: "Video",
                  MediaURL: "https://smart-md.oss-cn-shanghai.aliyuncs.com/template/%E7%AB%96%E7%89%88%E6%A8%A1%E6%9D%BF.mp4",
                  X: 0,
                  Y: 0,
                  AdaptMode: "Contain",
                  Width: 1,
                  Height: 0.999,
                  In: 1,
                  Out: 1,
                  TimelineIn: 0,
                  TimelineOut: 20,
                  Duration: 20,
                  Speed: 1,
                  TrackId: Id
                }
              ]
            },
            {
              Id: Date.now() + parseInt(String(Math.random() * 10000)),
              Type: "Image",
              VideoTrackClips: []
            },
            {
              Id: Date.now() + parseInt(String(Math.random() * 10000)),
              Type: "SubTitle",
              VideoTrackClips: [
                {
                  Id: Id1,
                  Type: "Text",
                  X: 0.5,
                  Y: 0.67,
                  Content: "这是一条字幕,测试一下字幕的长度而已",
                  Alignment: "Center",
                  FontSize: 14,
                  FontColor: "#ffffff",
                  FontColorOpacity: 1,
                  EffectColorStyle: "",
                  Outline: 0,
                  OutlineColour: "",
                  Shadow: 0,
                  BackColour: "",
                  Font: "Alibaba PuHuiTi",
                  FontUrl: "",
                  FontFace: {
                    Bold: false,
                    Italic: false,
                    Underline: false
                  },
                  TimelineIn: 0,
                  TimelineOut: 20,
                  Spacing: 0,
                  LineSpacing: 0,
                  Angle: 0,
                  SubtitleEffects: [{
                    XBord: 0,
                    Color: '#ffffff',
                    Radius: 0,
                    Type: 'Outline'
                  }],
                  AdaptMode: "AutoWrap",
                  Duration: 0,
                  SizeRequestType: "RealDim",
                  BorderStyle: 1,
                  TrackId: Id1,
                  TextWidth: 0.8
                }
              ]
            }
          ],
          AspectRatio: "9:16",
          From: "websdk",
          FECanvas: {
            Width: 253.125,
            Height: 450
          }
        }
      }),
      custom_data: JSON.stringify({
        type: "normal",
        customList: [
          {
            "id": Id1,
            "coverType": 4
          }
        ],
        uploadList: [],
        AspectRatio: "9:16",
        From: "websdk",
        FECanvas: {
          Width: 253.125,
          Height: 450
        }
      })
    }]
  }
  // 替换函数
  return (
    <Profiler id="App" onRender={onRenderCallback}>
      <mixCutDetailContext.Provider
        value={{
          videoGroupActive,
          setVideoGroupActive,
          videoGroupTransitionId,
        }}
      >
        <div className="mix-cut-detail-wrapper">
          <Header
            mode={'quickcut'}
            updateTime={projectMsg?.updated_at}
            handleResultBtnClick={async () => {
              if (!QuickCutStore.quickcutData.scenes.every((item) => item.materials?.length > 0)) {
                Message.warning("分镜下需要添加素材！");
                return;
              }
              if (QuickStore.quickcutData.global) {
                if (QuickStore.quickcutData.settings.general.mode === 'custom') {
                  const obj = QuickCutStore.quickcutData.scenes.find(item => !item.duration && item.type === 2)
                  if (obj) {
                    Message.warning(`分镜${obj.name}自定义时长不能为空！`);
                    return
                  }
                }
                if (!QuickCutStore.quickcutData.settings.copy.copy_id) {
                  Message.warning("请选择文案库！");
                  return
                }
              }
              if (!QuickStore.quickcutData.global) {
                const obj = QuickCutStore.quickcutData.scenes.find(item => item.settings.general.mode === 'custom' && !item.duration)
                if (obj) {
                  Message.warning(`分镜${obj.name}自定义时长不能为空！`);
                  return
                }
                const copyIdFlag = QuickCutStore.quickcutData.scenes.find(item => item.settings.general.mode === 'follow_audio' && !item.settings.copy.copy_id && item.type == 2)
                if (copyIdFlag) {
                  Message.warning(`分镜${copyIdFlag.name}内文案描述不能为空！`);
                  return
                }
              }
              if (QuickCutStore.quickcutData.settings.copy.voice.speaker?.length === 0) {
                Message.warning("请选择配音！");
                return
              }
              if (!QuickCutStore.outputCount) {
                Message.warning("请输入生成数量！");
                return
              }
              // setComponseVisible(true);
              await quickSaveMixCutDetail();
              getPreviewInfo()
            }}
            name={projectMsg?.title}
            handleChangeName={(e) => {
              handleProjectName(e);
            }}
          ></Header>
          <div className="mix-cut-detail-container">
            <VideoGroup
              videoStatusList={videoStatusList}
              handleHeaderItemClick={(id) => {
                const index = projectSences.findIndex((item) => item.id === id);
                const activeType = projectSences.find((item) => item.id === id)?.type
                setActiveType(activeType)
                setVideoGroupActive(index);
              }}
              handleVideoGroupAdd={(e: number) => {
                handleProjectSencesAdd(e);
              }}
              handleVideoGroupDelete={(index) => {
                handleProjectSencesDelete(index);
              }}
              data={projectSences}
              handleProjectVideoChange={handleProjectVideoChange}
              handleDataChange={(e) => {
                setProjectSences(e);
              }}
              handleChangeVideoItemStartAndDuration={
                handleChangeVideoItemStartAndDuration
              }
              handleTransitionBtnClick={(e) => {
                console.log(e, 'e')
                setTansIndex(e)
                setTransVisible(true)
              }}
            ></VideoGroup>
            {
              <VideoConfig
                activeType={activeType}
                videoConfigActiveIndex={videoConfigActiveIndex}
                handleVideoConfigActiveIndexChange={setVideoConfigActiveIndex}
                CationConfig={projectCaption}
                ></VideoConfig>
            }
            {
              !componseVisible && <PreviewingVideo activeIndex={videoGroupActive}></PreviewingVideo>
            }
            {
              transVisible && <ChooseTransModal checkedIds={[]} transIndex={transIndex} visible={transVisible} handCancel={() => {
                setTransVisible(false)
              }} />
            }
          </div>
        </div>
      </mixCutDetailContext.Provider>
      {componseVisible ? (
        <ComponseModal
          timelineInfo={timelineData}
          showPreview={true}
          videoNumber={QuickCutStore.outputCount}
          onCancel={() => {
            setComponseVisible(false);
          }}
          count={count}
          onOk={async (e) => {
            console.log(e, 'e')
            try {
              const scenesWithUpdatedDuration =
                QuickStore.quickcutData.scenes.map((item) => ({
                  ...item,
                  duration: item.duration * 1000,
                }));
              const Id = Date.now() + parseInt(String(Math.random() * 10000));
              const Id1 = Date.now() + parseInt(String(Math.random() * 10000));
              const taskData = {
                ...QuickStore.quickcutData,
                scenes: scenesWithUpdatedDuration,
                transitions: processTransitions(QuickStore.quickcutData.transitions),
                ...(Array.isArray(
                  QuickStore.quickcutData.settings?.video_template
                ) && QuickStore.quickcutData.settings?.video_template.length > 0
                  ? {
                      settings: {
                        ...QuickStore.quickcutData.settings,
                        video_template: QuickStore.quickcutData.settings.video_template,
                      },
                    }
                  : {
                      settings: {
                        ...QuickStore.quickcutData.settings,
                        video_template: makerVideo()
                      },
                    }),
              };
              const taskInit = {
                data: JSON.stringify(taskData),
                folder_id: Number(e.parent_id),
                session_id: Number(id),
                resolution: e.proportion,
                bitrate: Number(e.bitrate),
                fps: e.fps,
                project_id: Number(e.project_id),
                result_limit: QuickCutStore.outputCount,
              };
              xun_clip({
                ...taskInit,
              }).then((res) => {
                Message.success("合成任务提交成功！");
                setComponseVisible(false);
              });
            } catch (e) {
              // Message.success(e);
            }
          }}
          visible={componseVisible}
        />
      ) : (
        <></>
      )}
    </Profiler>
  );
});

export default QuickCut;
